import { FC } from 'react';
import { css } from '@emotion/react';
import { TeamChatTypes } from '@frontend/api-team-chat';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Text, Button } from '@frontend/design-system';
import { getUserFullName } from '../../../utils';
import { ChatAvatar } from '../../common/chat-avatar/chat-avatar';

interface UserListItemProps {
  user: TeamChatTypes.User;
  isMemberAdded: boolean;
  removeMember: (userId: string) => void;
  addMember: (userId: string) => void;
}

export const UserListItem: FC<UserListItemProps> = ({ user, isMemberAdded, removeMember, addMember }) => {
  const { t } = useTranslation('team-chat');

  return (
    <div css={userContainerStyle} key={user.userID}>
      <ChatAvatar users={[user]} />
      <Text>{getUserFullName(user.firstName, user.lastName)}</Text>
      {isMemberAdded && (
        <Button
          variant='tertiary'
          onClick={() => removeMember(user.userID)}
          css={marginLeftAuto}
          destructive
          trackingId='team-chat-2.0-create-channel-remove-user-from-list'
        >
          {t('Remove')}
        </Button>
      )}
      {!isMemberAdded && (
        <Button
          variant='tertiary'
          css={[marginLeftAuto]}
          onClick={() => addMember(user.userID)}
          trackingId='team-chat-2.0-create-channel-add-user-to-list'
        >
          {t('Add')}
        </Button>
      )}
    </div>
  );
};

const userContainerStyle = css({
  display: 'flex',
  gap: theme.spacing(1),
  alignItems: 'center',
  padding: theme.spacing(1.5, 2),
  borderBottom: `1px solid ${theme.colors.neutral10}`,
});

const marginLeftAuto = css({ marginLeft: 'auto' });
